import type { SearchHit } from 'bundles/search-common/providers/searchTypes';
import { isSearchProductHit } from 'bundles/search-common/utils/utils';

type ProductInput = {
  productId?: string;
  productType?: string;
};

type AiCoachProductInput = {
  productId: string;
  productType: 'SPECIALIZATION' | 'COURSE';
};

export function isAiCoachProductInput(input: ProductInput): input is AiCoachProductInput {
  return !!input.productId && !!input.productType && ['SPECIALIZATION', 'COURSE'].includes(input.productType);
}

export function filterForValidChatProducts(searchHits: SearchHit[]): AiCoachProductInput[] {
  return searchHits
    .filter(isSearchProductHit)
    .filter((p) => !!p.productType && ['COURSE', 'SPECIALIZATION'].includes(p.productType) && !!p.productCard?.id)
    .map(
      (p): ProductInput => ({
        productId: p.productCard?.id,
        productType: p.productType ?? undefined,
      })
    )
    .filter(isAiCoachProductInput);
}
